<div class="jhm-modal-background">
  <div id="connect-inmate-modal" class="jhm-modal connect-inmate-modal">
    <div class="top-icons">
      @if (!isConnecting && !isConnected && !isErrored) {
        <div class="credit-give-icon">
          <img src="./assets/images/credit-give-blue.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
      @if (isConnecting && !isConnected && !isErrored) {
        <div class="orange-spinner">
          <img src="./assets/images/spinner-orange.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
      @if (!isConnecting && isConnected && !isErrored) {
        <div class="success">
          <img src="./assets/images/credits-success.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
      @if (!isConnecting && !isConnected && isErrored) {
        <div class="exclamation">
          <img src="./assets/images/exclamation-triangle.svg">
        </div>
        <img class="cancel-button" src="./assets/images/black-x.svg" (click)="cancel()">
      }
    </div>
    @if (!isConnecting && !isConnected && !isErrored) {
      <div>
        <div class="description">
          <span class="connect-inmate">Connect your inmate account.</span> by filling out the details below.
        </div>
        <div class="horizontal-line horizontal-line-give"></div>
        <div class="input-title">Find your Jurisdiction</div>
        <mat-form-field appearance="outline" class="search">
          <input matInput [(ngModel)]="searchQuery" (ngModelChange)="this.searchQueryUpdate.next($event)" placeholder="Search for a jurisdiction..." #input>
        </mat-form-field>
        @if ((!jurisdictions || jurisdictions?.length < 1) && searchQuery?.length > 0) {
          <div class="no-jurisdictions">
            No jurisdictions found
          </div>
        }
        @if (jurisdictions?.length > 0) {
          <div class="jurisdictions">
            @for (jurisdiction of jurisdictions; track jurisdiction; let isFirst = $first; let isLast = $last) {
              <div class="line-item" [class.first]="isFirst" [class.last]="isLast">
                <div class="name-and-select">
                  <div class="name">
                    {{jurisdiction.name}}
                  </div>
                  <div class="select-jurisdiction">
                    <img src="./assets/images/add.svg" (click)="selectJurisdiction(jurisdiction)">
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (selectedJurisdiction && !isConnecting && !isConnected && !isErrored) {
      <div>
        Inmate Username
        <mat-form-field appearance="outline" class="search">
          <input matInput [(ngModel)]="username">
        </mat-form-field>
        Inmate Password
        <mat-form-field appearance="outline" class="search">
          <input matInput [(ngModel)]="password" type="password">
        </mat-form-field>
      </div>
    }
    @if (isConnecting) {
      <div>
        <div class="description">
          <span class="emphasize">Connecting your account.</span> Hold on for just a moment...
        </div>
      </div>
    }
    @if (isConnected) {
      <div>
        <div class="description">
          <span class="emphasize">Account connected successfully!</span>
          <div class="horizontal-line horizontal-line-give"></div>
          <div>You can now view the messages you received as an inmate at <span class="emphasize">{{selectedJurisdiction?.name}}</span> by visiting your inbox.</div>
        </div>
      </div>
    }
    @if (isErrored) {
      <div>
        <div class="description">
          <span class="emphasize">There was a problem connecting your account.</span>
          <div class="horizontal-line horizontal-line-give"></div>
          <div>Try entering the details again. If the problem persists, contact the jurisdiction.</div>
        </div>
      </div>
    }
    @if (!isConnecting && !isConnected && !isErrored) {
      <footer class="filled">
        <button class="jhm-button" (click)="cancel()">Back</button>
        <button class="jhm-button primary" (click)="connectAccount()">Connect Account</button>
      </footer>
    }
    @if (isConnected) {
      <footer>
        <button class="jhm-button" (click)="cancel()">Done</button>
        <button class="jhm-button primary" (click)="goToInbox()">Go to my inbox</button>
      </footer>
    }
    @if (isErrored) {
      <footer>
        <button class="jhm-button" (click)="cancel()">Cancel</button>
        <button class="jhm-button primary" (click)="tryAgain()">Try again</button>
      </footer>
    }
  </div>
</div>